import { z } from "zod";
import type { DocumentTypeConfig } from "../types";

export { isAllowedCountryCode } from "../rules";

export const PassportDataSchema = z.object({
  first_name: z.string(),
  last_name: z.string(),
  birth_date: z.string(),
  birth_place_city: z.string(),
  birth_place_country_code: z.string().optional(),
  sex: z.enum(["male", "female", "neutral"]),
  nationality_country_code: z.string(),
  issue_date: z.string(),
  expiration_date: z.string(),
  document_number: z.string(),
});

export type PassportData = z.infer<typeof PassportDataSchema>;

export const PassportExtractionSchema = z.object({
  isValidDocumentType: z.boolean(),
  reason: z.string().optional(),
  first_name: z.string().nullable(),
  last_name: z.string().nullable(),
  birth_date: z.string().nullable(),
  birth_place_city: z.string().nullable(),
  birth_place_country_code: z.string().nullable(),
  sex: z.enum(["male", "female", "neutral"]).nullable(),
  nationality_country_code: z.string().nullable(),
  issue_date: z.string().nullable(),
  expiration_date: z.string().nullable(),
  document_number: z.string().nullable(),
});

export type PassportExtraction = z.infer<typeof PassportExtractionSchema>;

export const PassportContextSchema = z.object({
  talentId: z.guid(),
});

export type PassportContext = z.infer<typeof PassportContextSchema>;

type PassportConfig = DocumentTypeConfig<typeof PassportDataSchema, typeof PassportContextSchema>;

export const PASSPORT_CONFIG: PassportConfig = {
  documentType: "passport",
  documentName: "Passeport",
  maxFiles: 1,
  acceptedMimeTypes: ["image/jpeg", "image/png", "application/pdf"],
  dataSchema: PassportDataSchema,
  contextSchema: PassportContextSchema,
  requiredFields: [
    "first_name",
    "last_name",
    "birth_date",
    "birth_place_city",
    "sex",
    "nationality_country_code",
    "expiration_date",
    "issue_date",
    "document_number",
  ],
  fieldLabels: {
    first_name: "Prénom",
    last_name: "Nom",
    birth_date: "Date de naissance",
    birth_place_city: "Ville de naissance",
    birth_place_country_code: "Pays de naissance",
    sex: "Sexe",
    nationality_country_code: "Nationalité",
    issue_date: "Date de délivrance",
    expiration_date: "Date d'expiration",
    document_number: "Numéro de document",
  },
};
